import useApi from '../../../../services/useApi'
import {ProjectDetailsContext} from '../../context'
import {useContext} from 'react'

const useGetProjectKanbanStages = () => {
  const Api = useApi()
  const {projectId} = useContext(ProjectDetailsContext)
  const {data: response, isFetching} = Api.useGetQuery(`/agile/projects/${projectId}/columns`)

  return {
    projectKanbanStages: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetProjectKanbanStages
